import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, Sparkles, Compass, LogOut, PlusCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BadgePill } from "@/components/Brand";
import StudyCard from "@/components/StudyCard";

export default function Account() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [mine, setMine] = useState([]);

  useEffect(() => {
    api.get("/studies").then(({ data }) => {
      setMine(data.studies.filter((s) => s.is_member || s.is_host));
    });
  }, []);

  if (!user) return null;

  return (
    <div className="mx-auto max-w-4xl px-4 py-6 sm:px-6">
      <div className="flex items-center gap-4 rounded-3xl border border-[#E8E4DF] bg-white p-6 bp-card-shadow">
        <span className="grid h-16 w-16 place-items-center rounded-full bg-[#F36353]/12 text-[#F36353] font-display text-2xl font-bold">
          {user.name?.[0]?.toUpperCase() || "?"}
        </span>
        <div className="min-w-0 flex-1">
          <h1 className="font-display text-2xl font-bold tracking-tight text-[#0F3D66]">{user.name}</h1>
          <p className="text-sm text-[#6B6763]">{user.email}</p>
          <div className="mt-2">
            {user.tier === "curator"
              ? <BadgePill tone="primary"><Sparkles size={12} /> Curator</BadgePill>
              : <BadgePill tone="muted"><Compass size={12} /> Free plan</BadgePill>}
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-3">
        {user.tier === "curator"
          ? <Button onClick={() => nav("/curator")} data-testid="account-create-btn" className="rounded-full bg-[#748C70] text-white hover:bg-[#5f7259]"><PlusCircle size={16} className="mr-1.5" /> Curator back office</Button>
          : <Button onClick={() => nav("/upgrade")} data-testid="account-upgrade-btn" className="rounded-full bg-[#F36353] text-white hover:bg-[#D94A3D]"><Sparkles size={16} className="mr-1.5" /> Upgrade to Curator</Button>}
        <Button onClick={async () => { await logout(); nav("/"); }} variant="outline" data-testid="account-logout-btn" className="rounded-full border-[#E8E4DF]"><LogOut size={16} className="mr-1.5" /> Log out</Button>
      </div>

      <h2 className="mb-3 mt-8 font-display text-lg font-semibold text-[#0F3D66]">My studies</h2>
      {mine.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-[#E8E4DF] bg-white p-8 text-center text-sm text-[#6B6763]">
          You haven't joined a study yet. <button onClick={() => nav("/plaza")} className="font-semibold text-[#F36353]">Explore the Plaza →</button>
        </div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2">{mine.map((s, i) => <StudyCard key={s.id} study={s} index={i} />)}</div>
      )}
    </div>
  );
}
